// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"648df3f5","247":"7f9d64db","513":"1f5f6c53","625":"84efc53e","706":"cc727622"}[chunkId] + ".chunk.js";
};